import { render, staticRenderFns } from "./upcoming_events.vue?vue&type=template&id=1d241aa9&scoped=true"
import script from "./upcoming_events.vue?vue&type=script&lang=js"
export * from "./upcoming_events.vue?vue&type=script&lang=js"
import style0 from "./upcoming_events.vue?vue&type=style&index=0&id=1d241aa9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d241aa9",
  null
  
)

export default component.exports